import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';
import { UtilsService } from '../../../services/shared/utils/utils.service';

@Component({
  selector: 'app-component-type-modal',
  templateUrl: './add-component-modal.component.html',
  styleUrl: './add-component-modal.component.css'
})
export class AddComponentModalComponent {

  selectedGroupId: string = "0";

  groupsInfo: { id: string, title: string, freeSpace: number, selected: boolean }[] = [];
  constructor(private dialogRef: MatDialogRef<AddComponentModalComponent>, private utils: UtilsService, @Inject(MAT_DIALOG_DATA) public data: { groupsInfo: { id: string, title: string, freeSpace: number, selected: boolean }[] }) {
    this.groupsInfo = data.groupsInfo;

    var groupSelected = this.groupsInfo.find(group => group.selected);
    if(groupSelected){
      this.selectedGroupId = groupSelected.id;
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    const result = {
      selectedGroupId: this.selectedGroupId === "0" ? undefined : this.selectedGroupId
    };

    this.dialogRef.close(result);
  }
}


